var styles = {"box-full":"ScreenLoader_box-full_1gxzy_1","box-component":"ScreenLoader_box-component_1gxzy_14","parent-container-height":"ScreenLoader_parent-container-height_1gxzy_19","animation":"ScreenLoader_animation_1gxzy_26"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
